export interface RecordPageHeading {
  title: string;
  subtitle: string | null;
}

export function toRecordPageHeading(input: {
  meaning?: string | null;
  key?: string | null;
  id?: string | null;
  fallbackTitle: string;
}): RecordPageHeading {
  const meaning = input.meaning?.trim() ?? '';
  const key = input.key?.trim() ?? '';
  const id = input.id?.trim() ?? '';
  const title = meaning || key || input.fallbackTitle;
  const identity = [key, id].filter(value => value && value !== title);
  return {
    title,
    subtitle: identity.length ? identity.join('\n') : null,
  };
}
